var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-wrapper"},[_c('data-table',{ref:"gpnSysLoginList",staticClass:"bs bs-data-table bs-data-table-slim analysis-panel-datatable",staticStyle:{"height":"100%"},attrs:{"data":_vm.widgetData,"fields":_vm.dataTableColumns,"resize-mode":'overflow',"virtual-scrolling":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }